import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { useNavigate } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import GeralTable from "./MenuTabela";
import APIAxios from "../../Api/APIAxios";
import Autocomplete from "@mui/material/Autocomplete";
import PageTitle from "../../Components/Layout/PageTitle";

const URL_SERVICE = "/menu";

const MenuListar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(3); //Cadastro de Menu
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();

  const [cmpSelecao, setCmpSelecao] = useState(10); // default: descrição
  const [menu, setMenu] = useState([]);
  const [valorSelecionado, setValorSelecionado] = useState(""); // NOVO
  const Navigate = useNavigate();

  const handleListar = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    const response = await GetAPI(apiAxios, URL_SERVICE);
    setLoading(false);

    if (!response.success) {
      setAvisoErro(response.errorMessage);
    } else {
      setMenu(response.data);
    }
  };

  useEffect(() => {
    handleListar();
  }, []);

  //Função para seleção de filtro
  const getAutocompleteOptions = () => {
    let options = [];

    switch (cmpSelecao) {
      case 10:
        options = menu.map((item) => item.descricao);
        break;
      case 20:
        options = menu.map((item) => item.grupo);
        break;
      default:
        return [];
    }

    // Remove duplicados
    const uniqueOptions = [...new Set(options)];

    // Ordena de forma alfabética ou numérica
    return uniqueOptions.sort((a, b) => {
      if (typeof a === "string") return a.localeCompare(b); // ordenação alfabética
      return a - b; // ordenação numérica
    });
  };

  // NOVO: Filtra conforme o valor selecionado
  const menuFiltrado = valorSelecionado
    ? menu.filter((item) => {
        const valor = valorSelecionado.toLowerCase();
        switch (cmpSelecao) {
          case 10:
            return item.descricao.toLowerCase().includes(valor);
          case 20:
            return item.grupo.toLowerCase().includes(valor);
          default:
            return true;
        }
      })
    : menu;

  const handleIncluirMenu = () => {
    Navigate("/menuboot/incluir");
  };

  return (
    <Box>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Menu"
        subtitle="Listagem de Menu"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}

      <Box sx={{ color: "red", marginBottom: 2 }}>
        <Grid container spacing={2} alignItems={"center"}>
          {/*Usar meia tela em caso de monitor grande e tela total em monitores pequenos*/}
          <Grid item xs={12} md={3}>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <FormControl fullWidth>
                <InputLabel>Filtrar por:</InputLabel>
                <Select
                  labelId="cmpSelecao"
                  id="cmpSelecao"
                  label="Filtrar por"
                  value={cmpSelecao}
                  onChange={(e) => setCmpSelecao(e.target.value)}
                >
                  <MenuItem value={10}>Descrição</MenuItem>
                  <MenuItem value={20}>Grupo</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              id="cmpDescricao"
              freeSolo
              options={getAutocompleteOptions()}
              value={valorSelecionado}
              onInputChange={(event, newValue) => setValorSelecionado(newValue)} // NOVO
              renderInput={(params) => (
                <TextField {...params} label="Localizar" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={3}></Grid>
          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ backgroundColor: "#1a3865" }}
              onClick={handleIncluirMenu}
            >
              Incluir Menu
            </Button>
          </Grid>
        </Grid>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
            }}
          >
            <CircularProgress size={50} />
          </Box>
        ) : (
          <GeralTable menu={menuFiltrado} setMenu={setMenu} />
        )}
      </Box>
    </Box>
  );
};

export default MenuListar;
